module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-chofer-gris.4124b9f4.svg";